import { render, staticRenderFns } from "./ResearchPheWAS.vue?vue&type=template&id=acdbfcc2"
import script from "./ResearchPheWAS.vue?vue&type=script&lang=js"
export * from "./ResearchPheWAS.vue?vue&type=script&lang=js"
import style0 from "./ResearchPheWAS.vue?vue&type=style&index=0&id=acdbfcc2&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acdbfcc2')) {
      api.createRecord('acdbfcc2', component.options)
    } else {
      api.reload('acdbfcc2', component.options)
    }
    module.hot.accept("./ResearchPheWAS.vue?vue&type=template&id=acdbfcc2", function () {
      api.rerender('acdbfcc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchPheWAS.vue"
export default component.exports